import React, { useEffect, useLayoutEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { setUserType } from "../../../redux/slices/userType";
import GlobalLoader from "./globalLoader";
import Header from "./header";
import Sidebar from "../../../../src/modules/business/shared/sidebar";
import offlineImg from "../../../assets/Offline.jpeg";
import { NotificationProvider } from "../pages/hooks/useNotification";

const BusinessLayout = () => {
  const dispatch = useDispatch();
  const loaderState = useSelector((state) => state.globalLoader);
  const navigate = useNavigate();
  window.navigate_ = navigate;

  const offlineModalOpen = useRef(null);
  const offlineModalClose = useRef(null);

  const isNetworkConnected = async () => {
    await fetch("https://www.google.com/", { mode: "no-cors" });
    offlineModalClose.current?.click();
  };

  const handleOnline = () => {
    offlineModalClose.current?.click();
  };

  const handleOffline = () => {
    offlineModalOpen.current?.click();
  };

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useLayoutEffect(() => {
    dispatch(setUserType("business"));
    Promise.all([import("../../../assets/business/css/style.css"), import("../../../assets/business/css/responsive.css")]).then(() => {
      dispatch(setGlobalLoader(false));
    });
  }, []);

  return (
    <>
      {/* Offline Modal Trigger Button */}
      <button type="button" ref={offlineModalOpen} className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></button>

      {/* Offline Modal */}
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content offline-modal-content">
            <button type="button" className="btn-close d-none" ref={offlineModalClose} data-bs-dismiss="modal" aria-label="Close"></button>
            <div className="modal-body">
              <div className="w-100 d-flex justify-content-center py-5">
                <div className="text-center">
                  <img className="offline-modal-img" src={offlineImg} alt="Offline" />
                  <h3 className="fs-22">No Internet Connection</h3>
                  <p>Check your internet connection and try again.</p>
                  <button onClick={isNetworkConnected} className="btn btn-primary mt-2">
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Layout Content */}
      {loaderState ? (
        <GlobalLoader />
      ) : (
        <div>
          <div
            className="sidebar-backdrop"
            onClick={() => {
              document.querySelector(".sidebar")?.classList.remove("show");
              document.querySelector(".sidebar-backdrop")?.classList.remove("show");
            }}
          />
          <NotificationProvider>
            <Header />
          </NotificationProvider>
          <Sidebar />
          <Outlet />
        </div>
      )}
    </>
  );
};

export default BusinessLayout;
